/* eslint-disable @typescript-eslint/no-explicit-any */
import { observer } from 'mobx-react-lite';
import { Tenancy_Rich_Asset_Type_Enum_Ps_Enum } from '@pypestream/api-services';

import { tableStore } from '../../stores/table-store';
import { ButtonOption } from './table';
import { EditableTableCellTextArea } from './editable-table-cell-textarea';
import { NodeColumns, RichAssetTypeConfig } from '../../stores';
import { getOrderedJson } from './utils';

type ButtonData = {
  type: 'button';
  options: ButtonOption[];
};

export const RichAssetContentCell = observer(
  ({ row, column }: { row: any; column: any }) => {
    const rowId = row.original.id;
    const columnId = column.id;
    const isNoneAssetType =
      tableStore.getValue(rowId, NodeColumns.richAssetType) ===
      Tenancy_Rich_Asset_Type_Enum_Ps_Enum.None;

    const onChangeConversion = (input: string) => {
      const assetType = tableStore.getValue(rowId, NodeColumns.richAssetType);

      if (
        assetType &&
        assetType === Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Button
      ) {
        const options = input?.split('|');
        const buttonOptions: ButtonOption[] = [];
        options.forEach((option) => {
          const data = option.split('~');

          if (data.length === 1) {
            const label = data[0];
            const dest = parseInt(data[1], 10);

            buttonOptions.push({
              label,
              dest,
            });
          }
        });

        return {
          type: 'button',
          options: buttonOptions,
        };
      } else {
        return input;
      }
    };

    const onRenderValue = (arg: any) => {
      const assetType = tableStore.getValue(
        rowId,
        NodeColumns.richAssetType
      ) as keyof RichAssetTypeConfig;

      if (
        !arg &&
        assetType &&
        assetType.toLowerCase() === Tenancy_Rich_Asset_Type_Enum_Ps_Enum.None
      ) {
        return '';
      }

      if (
        !arg &&
        assetType &&
        Object.values(Tenancy_Rich_Asset_Type_Enum_Ps_Enum).includes(
          assetType as Tenancy_Rich_Asset_Type_Enum_Ps_Enum
        )
      ) {
        // @TODO: remove it when we have all the asset types
        // if (assetType.toLowerCase() !== 'buttons') {
        //   return '';
        // }

        const result = getOrderedJson({
          value: tableStore.richAssetsConfig[assetType],
          rowId,
          columnId,
          stringify: true,
        });

        return result;
      }

      // Handle complex objects that might be richAssetContent
      if (typeof arg === 'object' && arg !== null) {
        // Try to stringify the object properly
        try {
          const result = getOrderedJson({
            value: arg,
            rowId,
            columnId,
            stringify: true,
          });

          return result;
        } catch {
          // If JSON.stringify fails, try to extract meaningful information
          if (arg && typeof arg === 'object') {
            // Check if it's a button-like object
            if ('type' in arg && 'options' in arg) {
              const buttonData = arg.options as ButtonData['options'];
              if (Array.isArray(buttonData)) {
                return buttonData
                  .map((option) => {
                    return `${option.label}~${option.dest}`;
                  })
                  .join('|');
              }
            }
            // For other objects, try to get a meaningful string representation
            const keys = Object.keys(arg);
            return keys.length > 0 ? `{${keys.join(', ')}}` : '{}';
          }
          return String(arg);
        }
      } else {
        return String(arg);
      }
    };

    return (
      <EditableTableCellTextArea
        rowId={rowId}
        columnId={columnId}
        disabled={isNoneAssetType}
        index={tableStore.getRowIndex(rowId)}
        onChangeConversion={onChangeConversion}
        renderValue={onRenderValue}
      />
    );
  }
);
